import { Navigate } from "react-router-dom";
import { useAuthContext } from "../context/authContextInstance";

export default function PrivateRoute({ children }) {
  const { isAuthenticated } = useAuthContext();

  if (!isAuthenticated) {
    // Si no está autenticado, redirigir al login
    return <Navigate to="/login" replace />;
  }

  // Si está autenticado, mostrar el contenido
  return children;
}
